import { ref } from 'vue'

import type { Ref } from 'vue'

interface FilterSearchOptions {
  initial: string | null
}

interface FilterSearchReturn {
  query: Ref<string>
}

export const useFilterSearch = ({ initial }: FilterSearchOptions): FilterSearchReturn => {
  const query = ref<string>(initial ?? '')

  return {
    query,
  }
}
